import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";

const promos = [
  {
    className: "promo-mosaic__card--large",
    image: "/images/generated/promo-pantry.png",
    eyebrow: "Pantry essentials",
    title: "Spices with real color and character",
    text: "Start with six hardworking jars for roasts, rice, beans, and weeknight sauces.",
    href: "/collections/ground-spices",
  },
  {
    image: "/images/generated/promo-rare.png",
    eyebrow: "Rare finds",
    title: "Hard to find. Easy to use.",
    href: "/collections/rare-ingredients",
  },
  {
    image: "/images/generated/promo-blends.png",
    eyebrow: "Mixed here",
    title: "Small-batch house blends",
    href: "/collections/blends",
  },
];

const PromoMosaic = () => (
  <section className="section promo-mosaic" aria-label="Featured collections">
    <div className="site-container promo-mosaic__grid">
      {promos.map((promo) => (
        <Link
          className={`promo-mosaic__card ${promo.className || ""}`}
          to={promo.href}
          key={promo.title}
        >
          <img src={promo.image} alt="" loading="lazy" />
          <span className="promo-mosaic__overlay" />
          <span className="promo-mosaic__content">
            <small>{promo.eyebrow}</small>
            <strong>{promo.title}</strong>
            {promo.text && <span>{promo.text}</span>}
            <span className="promo-mosaic__link">
              Explore <FiArrowUpRight aria-hidden="true" />
            </span>
          </span>
        </Link>
      ))}
    </div>
  </section>
);

export default PromoMosaic;
